<template>
    <div class="content">
		<Header></Header>
		<div class="home-content">
      <div class="home-page por">
        <div class="title ac fw7" style="margin: -20px 0 10px;">{{$t('asntitle')}}</div>
        <div class="answer-content mt20" v-if="question">
          <div class="qs-t ac">{{$t('asntitle2')}} : {{draw_num}}</div>
            <div class="answer-img mt20 ac">
              <img :src="question.image">
            </div>
            <div class="answer-t mt50">
              {{question.title}}
            </div>
            <div class="answer-list">
              <div class="" :class="{'active':answerT==key}" @click="answerClick(key)" v-for="(item,key,index) in question.answer">
                {{item}}
              </div>
            </div>
            <div class="ac mt20">
              <button class="btn btn-blue" @click="getAnswer()">{{$t('check')}}</button>
            </div>
        </div>
        <div class="home1-banner mt50">
          <img v-for="(item,index) in indexImg.image" :src="item.image" />
        </div>
      </div>
		</div>
      <div class="footer">
        <div class="home-bottom ac mt50">
          <div class="footer-content ac">
            <div class="icon icon1" @click="getType('luckyDraw')">
              <img src="../../static/images/menu-icon2.png" />
              <span>{{$t('Prize')}}</span>
              </div>
            <div class="icon icon1" @click="getType('referral')">
              <img src="../../static/images/menu-icon3.png" />
              <span style="white-space: nowrap;">{{$t('referral')}}</span>
            </div>
            <!-- <div class="icon icon1" @click="getType('winnerList')">{{$t('winnerList')}}</div> -->
            <div class="icon icon2" @click="getType('faq')">
              <img src="../../static/images/menu-icon5.png" />
              <span>{{$t('FAQs')}}</span>
            </div>
            <div class="icon icon3" @click="getType('termsAndCondition')">
              <img src="../../static/images/menu-icon6.png" />
              <span>{{$t('TC')}}</span>
            </div>
            <div class="icon icon4" @click="getType('language')">
              <img src="../../static/images/menu-icon7.png" />
              <span>{{$t('language')}}</span>
            </div>
          </div>
        </div>
        <div class="copyright">{{$t('Copyright')}}</div>
      </div>
      <div class="modal defModal" v-if="isShow">
        <div class="modal-bg" style="background: rgba(0,0,0,.2);"></div>
        <div class="modal-content" style="width: 100%;margin-left: -50%;">
          <div class="modal-content2">
            <img width="" src="../../static/images/prize.gif" />
          </div>
        </div>
      </div>
      <Dialog ref="answerDialog" type="alert" :callback="answerModal" title="" width="100" :modalFoot="false">
          <div class="" slot="mdBox" >
            <div class="answer-modal" v-if="answerReson.is_correct==1">
              <div style="width:90%;margin:0 auto">
                <div class="">
                  <div class="title dui">{{$t('Correct')}}:)</div>
                  <img width="100" src="../../static/images/dui.png" />
                  <div class="answer-t1">
                    {{$t('ansTitle1')}}
                  </div>
                  <div class="answer-t2">
                    {{$t('ansTitle2')}}{{answerReson.num}}{{$t('ansTitle22')}}
                  </div>
                  <button class="btn btn-blue1 mt20" @click="answerModal">{{$t('OK')}}</button>
                </div>
              </div>
            </div>
            <div class="answer-modal answer-modal-cuo" v-if="answerReson.is_correct==0">
              <div style="width:90%;margin:0 auto">
                <div class="">
                  <div class="title cuo">{{$t('wrong')}} :(</div>
                  <img width="100" src="../../static/images/cuo.png" />
                  <div class="answer-t1">
                    {{$t('ansTitle3')}}
                  </div>
                  <div class="answer-t2">
                    {{$t('ansTitle2')}}{{answerReson.num}}{{$t('ansTitle22')}}
                  </div>
                  <button class="btn btn-blue1 mt20" @click="answerModal">{{$t('OK')}}</button>
                </div>
              </div>
            </div>
          </div>
      </Dialog>
      <Dialog ref="saveDialog" type="alert" :callback="saveModal" title="Reminder" width="100" :btnText="$t('goBack')" :cancelText="$t('goBack')">
          <div class="" slot="mdBox" >
              <img width="" style="position: absolute;left: 0;" src="../../static/images/prize.gif" />
            <div class="home-modal por">
              <div style="width:360px;margin:0 auto">
               <!-- <div class="mt10">
                  <img width="230" src="../../static/images/landing-x.png" />
                </div> -->

                <div class="mt20 tips" style="font-size:30px" v-html="modalList.tip"></div>
                <div class="mt20 app-en" v-for="(item,index) in modalList.list">
                  <!-- <div class="mt20"><img height="60" :src="item.image" /></div> -->
                  <div class="mt10 home-pz-t" v-html="item.name"></div>
                </div>
              </div>
            </div>
          </div>
      </Dialog>
      <Dialog ref="subscribeDialog" type="alert" :callback="getBUySubmit" title="Reminder" width="100" :btnText="$t('OK')" :cancelText="$t('OK')">
          <div class="login-content" slot="mdBox">
            <div class="pt20" style="padding-top:50px">
              <a class="logo" href="/"><img src="static/images/logo1.png" /></a>
            </div>
            <div class="login">
                <div class="login-c ac">
                  <div class="ac" style="font-size:40px;margin:30px auto 30px;color:#c20b0b;text-transform: uppercase;padding-top: 30px;" v-html="$t('cgtips1')"></div>
                  <div class="ac" style="color:#001d80;margin:0 auto 40px;font-size:36px;" v-html="$t('cgtips2')"></div>
                </div>
            </div>
          </div>
      </Dialog>
      <div class="modal login-modal" v-if="isShow3">
        <div class="modal-bg"></div>
        <div class="modal-content modal-content2">
          <img :src="popupImage" />
          <div class="close ac app-en" @click="getClose">x</div>
        </div>
      </div>

	</div>
</template>
<script>
import Header from '../components/headerNo'
import Dialog from '../components/dialog'
export default {
    components:{
		Header,Dialog
    },
    data() {
      return {
        info:{},
        isShow:false,
        isShow2:false,
        isShow3:false,
        keywords:'',
        notFound:false,
        indexImg:[],
        clickIndex:'',
        modalList:{
          'list':[],
        },
        draw_num:'',
        answerT:'',
        question:{},
        answerReson:{},
        isEN:'bur',
        popupImage:null
      }
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
    if (this.$route.query.mobile){
      this.fastLogin();
    }else {
      this.getHome();
    }
    this.getPopup();
    this.isEN = localStorage.getItem('lang')
    this.info.hot = [
      {
        title:'choose me',
        img:'../../static/images/img1.png',
      },
      {
        title:'choose me',
        img:'../../static/images/img2.png',
      },{
        title:'choose me',
        img:'../../static/images/img3.png',
      },{
        title:'choose me',
        img:'../../static/images/img4.png',
      },{
        title:'choose me',
        img:'../../static/images/img5.png',
      },{
        title:'choose me',
        img:'../../static/images/img6.png',
      },
    ]
	},
    methods: {
      getType(type){
          this.$router.push({path:'/menu',query:{type:type}});
      },
      answerClick(item){
        this.answerT = item
      },
      getAnswer(){
        let that = this
        let data = {
          question_id:that.question.id,
          user_answer:that.answerT
        }
        that.$api.post('/api/index/answer',data,r =>{
          that.$parent.returnCode(r,function(){
            that.$parent.loadModal(false);
            that.answerReson = r.data
            that.$refs.answerDialog.showMaskFun();
          })
        })
      },
      answerModal(){
        this.$refs.answerDialog.closeMask();
        this.answerT = ''
        this.getHome();
      },
      getHome(){
        let that = this
        that.$api.post('/api/index/index',null,r =>{
        	that.$parent.returnCode(r,function(){
            that.$parent.loadModal(false);
            that.indexImg = r.data
            that.question = r.data.question
            that.draw_num = r.data.draw_num
        	})
        })
      },
      saveModal(){
        this.$refs.saveDialog.closeMask()
        this.isShow2=true;
      },
      getSearch(keywords){
        this.$router.push({path:'/searchList',query:{keywords:this.keywords}});
      },
      getBUy(){
        this.$refs.subscribeDialog.showMaskFun();
      },
      getBUySubmit(){
          let that = this
          let data = {
            'mobile':localStorage.getItem('mobile'),
            'status':1
          }
           that.$api.post('/api/subscribe/status',data,r =>{
           	that.$parent.returnCode(r,function(){
              that.$parent.loadModal(false);
              that.$refs.subscribeDialog.closeMask();
              that.$utils.alertText(r.msg,80);
              that.getHome();
           	})
           })
      },
      fastLogin(){
        let that = this
        that.$parent.loadModal(true);
        let data = {
          'mobile':this.$route.query.mobile
        }
        that.$api.post('/api/user/fast_login',data,r =>{
          that.$parent.loadModal(false);
          if(r.code==1){
            localStorage.setItem('token',r.data.userinfo.token)
            localStorage.setItem('mobile',r.data.userinfo.mobile)
            this.getHome();
          }else{
            that.$utils.alertText(r.msg,80);
            this.$router.push({path:'land'})
          }
        })
      },
      getClose(){
        this.isShow3 = false
      },
      getPopup(){
        let that = this
        let data = {
        }
        that.$api.post('/api/index/popup_image',data,r =>{
          that.$parent.returnCode(r,function(){
            that.popupImage = r.data.image
            if(that.popupImage!==null){
              that.isShow3 = true
            }
          })
        })
      },

	}
}
</script>
<style scoped>
  .login-content{color:#fff;background:url(../../static/images/login-bg.png) no-repeat center top;margin-top: -45%;}
  .login{margin-top:240px;}
  .modal-footer .btn{width: 48%; background-size: cover;min-height: 120px;}


  .modal-content2{text-align:center;position:absolute;top:50%;left:50%;margin-top:-10px;border-radius:8px;margin-left: -45%;width: 90%;}
  .modal-content2 img{border-radius:20px;width: 270px;margin: 35px 0 0;}
  .close{
    background: rgb(255 255 255 / 20%);
    color: #fff;
    width: 100px;
    height: 100px;
    font-size: 60px;
    margin: 30px auto 0;
    border-radius: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/page/question.vue